import React, { Component } from "react";
import ImageStep1 from "../../assets/step-1.png";
import ImageStep2 from "../../assets/step-2.png";
import ImageStep3 from "../../assets/step-3.png";
import ImageStep4 from "../../assets/step-4.png";
import _directDownload from "../../assets/download-icon.png";
// import manualFile from "../../assets/pdf/PMG Project Proponent (Private) Manual.pdf";
import manualFile from "../../assets/pdf/PMG-Project.Proponent.Private.Manual.pdf";
import { Image } from "react-bootstrap";

class HowItWorksResponsive extends Component {
  render() {
    let { isDesktopView } = this.props;
    return (
      <div className={`how-it-works-responsive-wrapper`} id="how-it-works">
        <div className="container">
          <div
            className="how-it-works-section"
            data-test="how-it-works-section"
          >
            <h2 className="how-it-works-heading">How it Works</h2>
            <div className="how-it-works-responsive">
              <div className="flex-box">
                <div className="work-steps-responsive">
                  <span>Step 01</span>
                  <Image
                    src={ImageStep1}
                    alt="Login or Register"
                    className="image-one"
                    loading="lazy"
                  />
                  <h3>Login or Register</h3>
                </div>
                <div className="work-steps-responsive">
                  <span>Step 02</span>
                  <Image
                    src={ImageStep2}
                    alt="Create Project & Add Issues"
                    className="image-two"
                    loading="lazy"
                  />
                  <h3>Create Project & Add Issue(s)</h3>
                </div>
              </div>
              <div className="flex-box">
                <div className="work-steps-responsive">
                  <span>Step 03</span>
                  <Image
                    src={ImageStep3}
                    alt="Monitor Issues and status"
                    className="image-three"
                    loading="lazy"
                  />
                  <h3>Monitor Issues and status</h3>
                </div>
                <div className="work-steps-responsive last-work-step">
                  <span>Step 04</span>
                  <Image
                    src={ImageStep4}
                    alt="Issue Resolved"
                    className="image-four"
                    loading="lazy"
                  />
                  <h3>Issue Resolved</h3>
                </div>
              </div>
            </div>
            <div style={{ paddingBottom: "13px" }}>
              <a
                href={manualFile}
                type="application/pdf"
                target="_blank"
                className="pdf-wrapper manual-wrapper"
                data-test="download-manual-link"
              >
                <Image src={_directDownload} alt="Issue Resolved" />
                {isDesktopView ? "Manual" : "Download Manual"}
              </a>
            </div>
            {/* <a
              href={manualFile}
              type="application/pdf"
              target="_blank"
              className="pdf-wrapper manual-wrapper"
              data-test="download-manual-link"
            >
              <Image src={_directDownload} alt="Issue Resolved" />
              {isDesktopView ? "Manual" : "Download Manual"}
            </a> */}
          </div>
        </div>
      </div>
    );
  }
}

export default HowItWorksResponsive;
